import * as React from 'react';
import { GeneralSettings } from '../Model';
import { Link, Text as TextControl } from '../CommonUI';
import Button from '../CommonUI/Control/Button';
import '../Assets/styles/component.css';
import '../Assets/styles/general.css';
import { Flex, Box } from '../CommonUI/Layout';
import { Text } from 'ilenia';

interface SettingsProps {
    settings: GeneralSettings;
    source: string;
    tierName: string;
    onChange: (settings: GeneralSettings) => void;
    onSettingsSave: () => void;
}

export class Settings extends React.Component<SettingsProps> {
    constructor(props: SettingsProps) {
        super(props);
        this.clearKey = this.clearKey.bind(this);
    }

    public componentDidMount() {
        analytics.page();
    }

    public clearKey() {
        const invitationTriggerData = {
            key: '',
        };
        this.props.onChange(invitationTriggerData);
    }

    public render() {
        const { settings, source, onSettingsSave, tierName } = this.props;
        return (
                <Box pb={30} mt={0}>
                    <Flex>
                        <TextControl
                            id="integration-key"
                            label="Containers.integrationKey"
                            value={settings.key}
                            disabled={true}
                        />
                        <Link
                            label="settings.clear"
                            track={{
                                placement: 'Under integration key TextBox',
                                target: 'Integration page key cleaner',
                                name: 'get-key-link',
                                source,
                                tierName,
                            }}
                            onClick={this.clearKey}
                        />
                        <Button
                            onClick={onSettingsSave}
                            saveTextId="Notifications.saveMessage"
                            track={{
                                placement: 'Bottom left corner',
                                action: 'Key saved in Settings tab',
                                name: 'key-save-settings-button',
                                source,
                                tierName,
                            }}
                        >
                            <Text id="invitations.save" />
                        </Button>
                    </Flex>
                </Box>
        );
    }
}
